module.exports = __webpack_public_path__ + "img/airfloss.08eb2bc8.jpg";